/* eslint-disable react/prop-types */
import React from "react";
import { Col, Row, Table, Button } from "react-bootstrap";
import FadeIn from "../../common/FadeIn";
import { Link } from "react-router-dom";
//Auth
import { isAuthenticatedCustomer } from "../services/CustomerAuth.js"; //import auth

const OtherClasses = (props) => {
  const otherClasses = props.otherClasses;
  if (otherClasses.length > 0) {
    return (
      <FadeIn delay={250} duration={450}>
        <Row className='mb-3 mt-5'>
          <Col>
            <h1 className='mt-4 text-center'>Alternative Classes...</h1>
          </Col>
        </Row>
        <Table striped bordered hover responsive className='text-center shadow'>
          <thead>
            <tr>
              <th className='d-none d-md-table-cell'>Day</th>
              <th className='d-none d-md-table-cell'>Time</th>
              <th className='d-none d-md-table-cell'>Venue</th>
              <th className='d-table-cell d-md-none'>Details</th> {/*MobileOnlyBlock*/}
              <th>Type</th>
              <th>Subscribe</th>
            </tr>
          </thead>
          <tbody>
            {otherClasses.map((ClassSession) => (
              <tr key={ClassSession._id}>
                <td className='align-self-center align-middle d-none d-md-table-cell'>
                  {ClassSession.Day}
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell'>
                  <strong>
                    {ClassSession.StartTime} - {ClassSession.FinishTime}
                  </strong>
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell'>
                  {ClassSession.Venue.VenueName}
                </td>
                {/*MobileOnlyBlockStarts*/}
                <td className='align-self-center align-middle d-table-cell d-md-none'>
                  {ClassSession.Day}
                  <br />
                  <strong>
                    {ClassSession.StartTime} - {ClassSession.FinishTime}
                  </strong>
                  <br />
                  {ClassSession.Venue.VenueName}
                </td>
                {/*MobileOnlyBlockEnds*/}
                <td className='align-self-center align-middle'>{ClassSession.LessonType}</td>
                {isAuthenticatedCustomer() ? (
                  <td className='align-self-center align-middle'>
                    {ClassSession.MaxLearners > ClassSession.Subscribers_Number ? (
                      <Button as={Link} to={`/checkout/${ClassSession._id}`} variant='success'>
                        Subscribe
                      </Button>
                    ) : (
                      <Button as={Link} to={`/checkout/${ClassSession._id}`} variant='secondary'>
                        Join Waiting List
                      </Button>
                    )}
                  </td>
                ) : (
                  ""
                )}

                {!isAuthenticatedCustomer() ? (
                  <td className='align-self-center align-middle'>
                    {ClassSession.MaxLearners > ClassSession.Subscribers_Number ? (
                      <Button as={Link} to={`/signup/${ClassSession._id}`} variant='success'>
                        Subscribe
                      </Button>
                    ) : (
                      <Button as={Link} to={`/signup/${ClassSession._id}`} variant='secondary'>
                        Join Waiting List
                      </Button>
                    )}
                  </td>
                ) : (
                  ""
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </FadeIn>
    );
  } else return "";
};

export default OtherClasses;
